import ValidationIntl from "./Validation.i";
import * as yup from "yup";

const schema = yup.string().required().email();

export default value => {
  return schema.isValidSync(value) ? undefined : ValidationIntl.Email;
};
